import React from 'react'
import { Box, Card, CardContent, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { noop } from 'lodash'
import PropTypes from 'prop-types'

const StyledCard = styled((props) => {
  const { selected, disabled, ...other } = props
  return <Card {...other} />
})(({ theme, selected, disabled }) => ({
  height: '100%',
  cursor: disabled ? 'default' : 'pointer',
  border: `4px solid`,
  borderColor: selected
    ? theme.palette.common.brand
    : theme.palette.common.white,
  opacity: disabled ? 0.7 : 1,
}))

function SelectableCard({
  disabled,
  icon,
  onClick,
  selected,
  subtitle,
  title,
}) {
  return (
    <StyledCard
      disabled={disabled}
      selected={selected}
      elevation={0}
      square
      onClick={onClick}
    >
      <CardContent
        sx={(theme) => ({
          padding: theme.spacing(3, 5),
          textAlign: 'center',
        })}
      >
        <Box component="span" sx={{ mb: 1 }}>
          {icon}
        </Box>
        <Typography variant="h3" align="center" sx={{ mt: 1, mb: 2 }}>
          {title}
        </Typography>
        <Typography variant="body1" align="center">
          {subtitle}
        </Typography>
      </CardContent>
    </StyledCard>
  )
}

SelectableCard.propTypes = {
  disabled: PropTypes.bool,
  icon: PropTypes.node,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  subtitle: PropTypes.string,
  title: PropTypes.string,
}
SelectableCard.defaultProps = {
  disabled: false,
  icon: null,
  onClick: noop,
  selected: false,
  subtitle: '',
  title: '',
}

export default SelectableCard
